import { useState } from "react";
import styles from "./buying-options.module.css";
import { useAppDispatch } from "@lib/hooks";
import { selectOption } from "@lib/features/cart/cartSlice";
import Link from "next/link";
import { useSelector } from "react-redux";
import { getWebsiteProductImageUrl } from "@/lib/product-presentation";

export default function BuyingOption({ product, alt_id, option }) {
    const items = useSelector((state) => state.cart.items);
    const cartItem = items[alt_id];
    const isSelected = cartItem && (cartItem.option?.id ?? cartItem.name?.id) === option.id;

    const [localQuantity, setLocalQuantity] = useState(1);
    const quantity = isSelected ? cartItem.quantity : localQuantity;

    const dispatch = useAppDispatch();
    const isRenewal = option.name.toLowerCase() === "renewal";
    const isContactSales = option.name.toLowerCase().includes("contact sales");
    const unitPrice = Number(option.price || 0);
    const totalPrice = (unitPrice * quantity).toFixed(2);
    const optionClassName = [
        styles.buyingOption,
        isSelected ? styles.buyingOptionSelected : "",
    ].filter(Boolean).join(" ");
    const productImage = getWebsiteProductImageUrl(product);

    const doSelect = (qty) => {
        dispatch(selectOption(alt_id, product.name, option, qty, productImage));
    };

    const handleContainerClick = (event) => {
        const target = event.target;
        if (
            (target.tagName.toLowerCase() === "input" && target.type === "number") ||
            (target.tagName.toLowerCase() === "input" && target.type === "radio")
        ) {
            return;
        }

        if (!isSelected) {
            doSelect(quantity);
        }
    };

    const handleOptionChange = () => {
        doSelect(quantity);
    };

    const handleQuantityChange = (event) => {
        const value = parseInt(event.target.value, 10);
        const newQty = isNaN(value) ? 1 : Math.max(1, value);
        setLocalQuantity(newQty);

        if (isSelected) {
            doSelect(newQty);
        }
    };

    if (isContactSales) {
        return (
            <div className={styles.buyingOptionContactSales}>
                <div className={styles.buyingOptionParts}>
                    <span className={`mb-0 fw-semibold ${styles.buyingOptionLabel}`}>
                        {option.name}
                    </span>
                </div>
                <Link href="/contact" className="btn btn-primary btn-sm">
                    Contact Us
                </Link>
            </div>
        );
    }

    return (
        <div className={styles.addedToCartWrapper}>
            <div
                className={optionClassName}
                onClick={handleContainerClick}
            >
                <input
                    type="radio"
                    name={`option-${alt_id}`}
                    id={`option-${alt_id}-${option.id}`}
                    className={`form-check-input ${styles.buyingOptionCheckbox}`}
                    checked={!!isSelected}
                    onChange={handleOptionChange}
                />
                <div className={styles.buyingOptionParts}>
                    <label
                        htmlFor={`option-${alt_id}-${option.id}`}
                        className={`mb-0 fw-semibold ${styles.buyingOptionLabel}`}
                    >
                        {option.name}
                    </label>
                    <div className={styles.buyingOptionPricing}>
                        <span className={styles.optionUnitPrice}>${unitPrice.toFixed(2)} each</span>
                        <span className={styles.optionPrice}>${totalPrice}</span>
                    </div>
                </div>
                <div className={styles.quantityContainer}>
                    <label htmlFor={`quantity-${alt_id}-${option.id}`} className="mb-0">
                        Qty
                    </label>
                    <input
                        type="number"
                        id={`quantity-${alt_id}-${option.id}`}
                        min={1}
                        max={99}
                        value={quantity}
                        onChange={handleQuantityChange}
                        className="form-control form-control-sm"
                    />
                </div>
                {!isRenewal && quantity > 10 && (
                    <div className={styles.contactMessage}>
                        For quantities over 10, please <a href="/contact">contact us</a>.
                    </div>
                )}
            </div>
        </div>
    );
}
